import { useEffect, useLayoutEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router';
import { useTheme } from '../lib/storage';
import { trackPageview } from '../lib/track';
import { Icon } from './Icon';

const useClientLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

export function Layout({ children }) {
  const { theme, setTheme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  const closeMenu = () => setMenuOpen(false);
  const handleNavigation = () => {
    closeMenu();
    window.scrollTo(0, 0);
  };

  useClientLayoutEffect(() => {
    if (!location.hash) window.scrollTo(0, 0);
    setMenuOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    trackPageview();
  }, [location.pathname]);

  return (
    <div className="site-shell">
      <a className="skip-link" href="#hoofdinhoud">Ga naar de inhoud</a>
      <header className="site-header">
        <div className="container header-inner">
          <Link className="brand" to="/" onClick={handleNavigation}>
            <img className="brand-logo" src="/logo-juzamma.png" alt="" aria-hidden="true" />
            <span>
              <strong>juzamma</strong><span>.nl</span>
            </span>
          </Link>

          <button
            className="icon-button menu-button"
            type="button"
            aria-label={menuOpen ? 'Menu sluiten' : 'Menu openen'}
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((open) => !open)}
          >
            <Icon name={menuOpen ? 'close' : 'menu'} />
          </button>

          <nav className={`main-nav ${menuOpen ? 'is-open' : ''}`} aria-label="Hoofdnavigatie">
            <NavLink to="/" end onClick={handleNavigation}><Icon name="book" />Soera’s</NavLink>
            <NavLink to="/quiz" onClick={handleNavigation}><Icon name="quiz" />Quiz</NavLink>
            <button
              className="theme-toggle"
              type="button"
              onClick={() => setTheme(theme === 'dark' ? 'light' : 'dark')}
              aria-label={theme === 'dark' ? 'Licht thema gebruiken' : 'Donker thema gebruiken'}
            >
              <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
              <span>{theme === 'dark' ? 'Licht' : 'Donker'}</span>
            </button>
          </nav>
        </div>
      </header>

      <main id="hoofdinhoud" tabIndex="-1" key={location.pathname}>{children}</main>

      <footer className="site-footer">
        <div className="container footer-grid">
          <div>
            <Link className="brand footer-brand" to="/" onClick={handleNavigation}>
              <img className="brand-logo" src="/logo-juzamma.png" alt="" aria-hidden="true" />
              <span><strong>juzamma</strong><span>.nl</span></span>
            </Link>
            <p>Lees en luister naar de 37 soera’s van Juz ‘Amma.</p>
          </div>
          <div>
            <h2>Handig</h2>
            <Link to="/quiz" onClick={handleNavigation}>Juz ‘Amma-quiz</Link>
          </div>
        </div>
        <div className="container footer-bottom">
          <p>Met zorg gemaakt voor Nederlandse gezinnen en beginners.</p>
        </div>
      </footer>
    </div>
  );
}
